export default {
  async uploadResource(context, payload) {
    console.log('uploadResource', payload);
  },

  async uploadLinkResource(context, payload) {
    console.log('uploadLinkResource', payload);
  },
};
